/**
 * Layout primitive for the 268px secondary column (history list, filters,
 * etc.) used by pages that need a workspace-style side panel. Pages wire
 * their own content into it; this component only owns the frame.
 */
export default function ContextPanel({ children }: { children: React.ReactNode }) {
  return (
    <aside className="hidden md:flex flex-col w-[268px] shrink-0 bg-[var(--cream-2)] border-r border-app p-[10px] overflow-hidden">
      {children}
    </aside>
  )
}
